




















































































































































































































import { Component, Vue } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";
import Loading from "@/shared/components/loading.vue";
import {
  NotificacoesAppleService,
  NotificacaoApple,
} from "@/services/notificacoes-apple.service";
import { dateTimeSeconds, date, cpf } from "@/shared/filters";
import DataTable from "@/shared/components/data-table.vue";
import { HomeService, FiltrosConsultor } from "@/services/home.service";
import Confirm from "@/shared/components/confirm.vue";

@Component({
  components: { DataTable, Modal, Loading, Confirm },
  filters: { dateTimeSeconds, date, cpf },
})
export default class AssociarNotificacaoApple extends Vue {
  consultor: Promise<any[]> | null = null;
  formAtivo: number | null = null;
  tableAtivo: number | null = null;
  idNotificacaoApple: number | null = null;

  loading = false;

  filtro: FiltrosConsultor = {
    txtPesquisa: "",
    offset: 0,
    limit: 100,
  };

  headers = [
    { value: "idConsultor", text: "ID" },
    { value: "nome", text: "Nome" },
    { value: "cpf", text: "CPF" },
    { value: "email", text: "Email" },
    { value: "dataCadastro", text: "Data Cadastro" },
    { value: "dataUltimoLogin", text: "Último Acesso" },
    { value: "ativo", text: "Ativo" },
  ];

  notificacaoApple: NotificacaoApple = {
    logNotificacaoApple: {
      ambiente: "",
      data: "",
      idLogNotificacaoApple: "",
      notificacao: "",
      origem: "",
      status: "",
    },
    receipt: {
      productId: "",
      originalPurchaseDate: "",
      expiresDate: null,
      originalTransactionId: "",
      transactionId: "",
      purchaseDate: "",
    },
  };

  get tituloManter(): string {
    return "Associar Notificação Apple";
  }

  public async associarNotificacaoApple(id: any) {
    this.idNotificacaoApple = id;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    this.formAtivo = 0;
    this.tableAtivo = 0;
    this.loading = true;
    const retorno = await NotificacoesAppleService.popAssociarNotificacao(
      id
    ).finally(() => (this.loading = false));
    this.notificacaoApple.logNotificacaoApple = retorno.logNotificacaoApple;
    this.notificacaoApple.receipt =
      retorno.notification.unifiedReceipt.latestReceiptInfo[0];
    return p;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  async pesquisar() {
    this.loading = true;
    try {
      if (this.filtro) {
        this.consultor = await HomeService.ListaConsultor(this.filtro);
      }
    } finally {
      this.loading = false;
    }
  }

  async selecionadoConsultor(item: any) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = "Esta ação não tem retorno!";
    const text =
      "Tem certeza que deseja ASSOCIAR os dados da Assinatura Apple selecionada ao consultor?";
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.loading = true;
      await NotificacoesAppleService.AssociarConsultor(
        this.idNotificacaoApple,
        item.idConsultor
      ).finally(() => {
        this.loading = false;
      });
      this.fechar();
    }
  }
}
